<template>
    <v-jsoneditor v-bind="$attrs"
                  v-on="$listeners"
                  :value="value"
                  :options="options"
                  height="600px"/>
</template>

<script>
import VJsoneditor from 'v-jsoneditor';

export default {
    name: "CampaignJsonEditor",
    components: {VJsoneditor},
    props: {
        value: {},
        readonly: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'change'
    ],
    model: {
        prop: 'value',
        event: 'change'
    },
    data() {
        return {
            options: {
                modes: ['code', 'tree', 'text'],
                onEditable: ({path, field, value}) => !this.readonly
            }
        };
    },
}
</script>

<style>
/* styling of the editor menubar*/
.jsoneditor-menu a.jsoneditor-poweredBy {
    color: #ffffff;
}

div.jsoneditor,
div.jsoneditor-menu {
    border-color: #00796B;
}

div.jsoneditor-menu {
    background-color: #00796B;
}

</style>
